import { environment } from '../../../../environments/environment';

export class PermissionService {
  static $inject = ['RestResource', 'UtilService'];

  constructor(private RestResource, private UtilService) {}

  utils = new this.UtilService(this);

  apiUrl = environment.apiEndpoint + 'permissions';

  getFilterCriteria() {
    var filterCriteria = {
      page: 1,
      sortDir: 'asc',
      sortedBy: 'name',
    };

    return filterCriteria;
  }

  getPermissions(filterCriteria) {
    if (!filterCriteria) {
      // Default criteria
      filterCriteria = this.getFilterCriteria();
    }

    return this.RestResource.request(
      'get',
      this.apiUrl,
      filterCriteria,
      function (response) {
        response = response.data;

        if (response.meta) {
          return {
            items: response.data,
            meta: this.utils.getItemsMetaData(response, filterCriteria),
          };
        } else {
          return {
            items: response,
          };
        }
      },
      {}
    );
  }

  getPermission(id, language) {
    var params = { lang: '' };

    if (language) {
      params.lang = language;
    }

    return this.RestResource.request(
      'get',
      this.apiUrl + '/' + id,
      params,
      function (response) {
        return response.data;
      },
      function () {
        return false;
      }
    );
  }

  addPropertiesToPermission(item, permission) {
    var userPermission = item && item.permissions ? item.permissions[permission.id] : null;
    // Set all the actions as object to get checked options
    // Check permission in into a item, and has an action
    for (var action in permission.actions_keys) {
      if (permission.actions_keys.hasOwnProperty(action)) {
        if (!permission.actions_keys[action].name) {
          permission.actions_keys[action] = {
            name: permission.actions_keys[action],
            action: action,
          };
        }

        if (userPermission && userPermission[action]) {
          // Edit
          item.permissions[permission.id].class = permission.subject_class;
          item.permissions[permission.id].category = permission.category;
          item.permissions[permission.id][action] = permission.id;
          permission.actions_keys[action].checked = true;
        } else {
          permission.actions_keys[action].checked = false;
        }
      }
    }
  }
}
